import { UserRole } from "types/user.type";

export const roleLabels: Record<UserRole, string> = {
  super_admin: "Super admin",
  admin: "Admin",
  manager: "Manager",
  employee: "Employé",
};
